export { DimensionTypes as InsightsGroupByTypes } from './dimension.types'
export { FormatterType as InsightsFormatterType } from './formatter.types'

export type InsightsFormatterFunction = (val: string | number) => string

export enum InsightsMetricDesiredDirection {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export {
  Instacart_Retailer_Tools_V2_InsightsPortalSchema as InsightsPortalSchema,
  Instacart_Retailer_Tools_V2_InsightsPortalOrderDirection as InsightsPortalOrderDirection,
} from '../../api'
